import React from 'react';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { SPACE_PERMISSIONS_SETTINGS } from '@confluence/named-routes/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

export const SpaceAnalyticsPermissionsRoute = ({ params: { spaceKey } }: RouteMatch) => (
	<Redirection href={SPACE_PERMISSIONS_SETTINGS.toUrl({ spaceKey, tab: 'analytics' })} />
);

SpaceAnalyticsPermissionsRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } }: RouteMatch,
	isNav4Enabled: boolean,
) => ({
	Screen: {
		screenEvent: { name: 'spaceAnalyticsPermissions', id: spaceKey },
		pageState: { routeName: name, spaceKey },
	},
	MainLayout: {
		spaceKey,
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
	},
});
